import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="5"
    height="10"
    viewBox="0 0 5 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.26654 3.58589L1.20654 0.525893C1.08163 0.401726 0.912659 0.332031 0.736535 0.332031C0.560411 0.332031 0.391443 0.401726 0.266535 0.525893C0.204049 0.587868 0.154453 0.661602 0.120607 0.742842C0.0867616 0.824081 0.0693359 0.911218 0.0693359 0.999226C0.0693359 1.08723 0.0867616 1.17437 0.120607 1.25561C0.154453 1.33685 0.204049 1.41058 0.266535 1.47256L3.3332 4.52589C3.39569 4.58787 3.44528 4.6616 3.47913 4.74284C3.51298 4.82408 3.5304 4.91122 3.5304 4.99923C3.5304 5.08723 3.51298 5.17437 3.47913 5.25561C3.44528 5.33685 3.39569 5.41059 3.3332 5.47256L0.266535 8.5259C0.140999 8.65055 0.0701225 8.81996 0.0694974 8.99687C0.0688723 9.17378 0.13855 9.34369 0.263202 9.46923C0.387854 9.59476 0.557269 9.66564 0.734178 9.66627C0.911087 9.66689 1.081 9.59721 1.20654 9.47256L4.26654 6.41256C4.64107 6.03756 4.85144 5.52923 4.85144 4.99923C4.85144 4.46923 4.64107 3.96089 4.26654 3.58589Z"
      fill="#98A3A9"
    />
  </svg>
);

const AngleRight = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default AngleRight;
